import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBook = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6 2C4.34375 2 3 3.34375 3 5V15C3 16.6562 4.34375 18 6 18H15H16C16.5531 18 17 17.5531 17 17C17 16.4469 16.5531 16 16 16V14C16.5531 14 17 13.5531 17 13V3C17 2.44687 16.5531 2 16 2H15H6ZM6 14H14V16H6C5.44688 16 5 15.5531 5 15C5 14.4469 5.44688 14 6 14ZM7 6.5C7 6.225 7.225 6 7.5 6H13.5C13.775 6 14 6.225 14 6.5C14 6.775 13.775 7 13.5 7H7.5C7.225 7 7 6.775 7 6.5ZM7.5 8H13.5C13.775 8 14 8.225 14 8.5C14 8.775 13.775 9 13.5 9H7.5C7.225 9 7 8.775 7 8.5C7 8.225 7.225 8 7.5 8Z",
		fill: "#0D2976"
	})
});
export default SvgBook;
